import { BookingDataItem, BookingFormMode } from "../booking_form.types";
import { mapRequirementToBookingData } from "../requirement_selector";
import { convertToWeekDayMask } from "../week_days_select.utils";
import { FetchPotentialWarnings } from "./fetch_potential_warnings";

export const mapToSingleBookingPayload = (
  {
    id,
    startDate,
    endDate,
    requirement,
    category,
    overridesDiaryTime,
    overridesNonWorkingTime
  }: Omit<BookingDataItem, "key">,
  values: FetchPotentialWarnings["values"],
  mode: BookingFormMode
) => {
  const { activityId, globalCategory, globalOverridesDiaryTime, globalOverridesNonWorkingTime } = values;
  const isCreateMode = mode === BookingFormMode.Create;
  const isCloneMode = [BookingFormMode.CloneSingle, BookingFormMode.CloneAll].includes(mode);
  return {
    id: isCreateMode || isCloneMode ? undefined : id,
    startDate,
    endDate,
    ...mapRequirementToBookingData(requirement),
    ...(activityId && { activityId }),
    bookingCategoryId: isCreateMode ? globalCategory?.id : category?.id,
    overridesCalendar: isCreateMode ? globalOverridesDiaryTime : overridesDiaryTime,
    overridesNonWorkingDays: isCreateMode ? globalOverridesNonWorkingTime : overridesNonWorkingTime
  };
};

export const mapToBookingTemplatePayload = (
  {
    bookingTemplateId,
    startDate,
    endDate,
    category,
    startTime,
    endTime,
    repeatDays,
    overridesDiaryTime,
    overridesNonWorkingTime
  }: Omit<BookingDataItem, "key">,
  values: FetchPotentialWarnings["values"],
  mode: BookingFormMode,
  profileId: number
) => {
  const { activityId, globalCategory, globalOverridesDiaryTime, globalOverridesNonWorkingTime } = values;
  const isCreateMode = mode === BookingFormMode.Create;
  const isCloneMode = [BookingFormMode.CloneSingle, BookingFormMode.CloneAll].includes(mode);
  return {
    profileId,
    id: isCreateMode || isCloneMode ? undefined : bookingTemplateId,
    startDate,
    endDate,
    startTime,
    endTime,
    wdayMask: convertToWeekDayMask(repeatDays?.selectedWeekDays ?? []),
    ...(activityId && { activityId }),
    bookingCategoryId: isCreateMode ? globalCategory?.id : category?.id,
    overridesCalendar: isCreateMode ? globalOverridesDiaryTime : overridesDiaryTime,
    overridesNonWorkingDays: isCreateMode ? globalOverridesNonWorkingTime : overridesNonWorkingTime
  };
};
